module.exports = __webpack_public_path__ + "img/published.891a4760.svg";